import React from 'react'
import { ColumnGroupDefinition } from '../types'
import { createColumns } from '../utils'
import MissionWeekValidateButton from '../../../missions/week-validate-button'
import { getDocIdAsString } from '../../../../utils/documents'
import { useValidateManyMutation } from '../../../../queries/work-periods'
import { Loader } from 'react-bulma-components'
import { isAuthorizedFor } from '../../../protected/protected'

/**
 * Creates a column group for week-level actions
 * @param props Component props
 * @returns Column group definition
 */
const weekActionsColumnsGroup = (): ColumnGroupDefinition => {
  return {
    Header: 'Actions',
    id: 'week-actions',
    columns: createColumns([
      {
        header: 'Valider',
        id: 'week-validate',
        className: 'table-section-end',
        shouldMerge: true,
        isHidden: !isAuthorizedFor(['employerMember']),
        render: data => {
          const mutation = useValidateManyMutation()
          const isCurrentMutation = mutation.variables?.workPeriodsIds.includes(
            getDocIdAsString(data.mission.workPeriods[0]),
          )

          if (isCurrentMutation && mutation.status === 'loading') {
            return <Loader />
          }

          if (isCurrentMutation && mutation.status === 'success') {
            return null
          }

          return (
            <MissionWeekValidateButton
              mission={data.mission}
              onClick={() =>
                mutation.mutate({
                  workPeriodsIds: data.mission.workPeriods
                    .filter(wp => wp.isValidated === false)
                    .map(wp => getDocIdAsString(wp)),
                  isValidated: true,
                })
              }
              size="smallest"
            />
          )
        },
      },
    ]),
  }
}

export default weekActionsColumnsGroup
